<template>
  <div class="content" id="app">
    <router-view></router-view>
    <!--     <div style="position: absolute; top: 0; z-index: 1000; opacity: 0.8; background: gray">
      <router-link to="/" style="color: white">Перейти к Main</router-link>
      <br />
      <router-link to="/login" style="color: white">Перейти к Login</router-link>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "app",
  mounted() {
    window.addEventListener("keydown", this.stopWindowZoom, { passive: false });
    window.addEventListener("mousewheel", this.stopWindowZoom, {
      passive: false,
    });
  },
  components: {},
  methods: {
    stopWindowZoom(e) {
      /*       if (
        event.ctrlKey == true &&
        (event.which == "61" ||
          event.which == "107" ||
          event.which == "173" ||
          event.which == "109" ||
          event.which == "187" ||
          event.which == "189" ||
          e.type === "mousewheel")
      ) {
        // 107 Num Key  +
        // 109 Num Key  -
        // 173 Min Key  hyphen/underscor Hey
        // 61 Plus key  +/= key
        event.preventDefault();
      } */
    },
  },
};
</script>

<style lang="scss">
body {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #6c6c6c;
  background-color: $color-gray-10;
  overflow: auto;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 1.65;
  user-select: none;
  outline: none;
}

.content {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;

  padding: 0;
  margin: 0;

  width: 100%;
  height: 100%;
  min-width: $content-min-width;
  min-height: $content-min-height;
}

//Set custom scrollbar
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: $color-gray-6;
  border-radius: 10px;
}

//Set custom moveable colors
.moveable-line {
  background: $color-yellow !important;
}

.moveable-control {
  background: $color-yellow !important;
  border-color: $color-yellow !important;
}
</style>
